import type { LucideIcon } from 'lucide-react'
import { FileText } from 'lucide-react'
import type { ArtifactResponse } from '@/client/types.gen'
import { ArtifactMetadataBlock } from '@/components/project/artifact-viewer/ArtifactMetadataBlock'
import { useTranslation } from '@/hooks/useTranslation'

export interface UnsupportedFileViewerProps {
	artifact: ArtifactResponse
	/** Optional icon to show instead of the default FileText (e.g. AudioLines for audio). */
	icon?: LucideIcon
	onDownload?: () => Promise<void>
	downloading?: boolean
}

export function UnsupportedFileViewer({
	artifact,
	icon: Icon = FileText,
}: UnsupportedFileViewerProps) {
	const { t } = useTranslation()

	return (
		<div className="p-4 space-y-6">
			<div className="flex flex-col items-center justify-center py-8 text-center">
				<Icon className="size-16 text-muted-foreground shrink-0" aria-hidden />
				<p className="mt-4 text-base font-medium text-foreground">
					{t('pages.projectDetail.artifactPreview.previewNotAvailable')}
				</p>
				<p className="mt-1 text-sm text-muted-foreground">
					{t('pages.projectDetail.artifactPreview.previewNotAvailableDescription')}
				</p>
			</div>
			<ArtifactMetadataBlock artifact={artifact} />
		</div>
	)
}
